<template>
  <div class="top-right-btn" :style="style">
    <el-row>
      <!-- ① 显示/隐藏搜索 -->
      <el-tooltip v-if="search" class="item" effect="dark" :content="showSearch ? '隐藏搜索' : '显示搜索'" placement="top">
        <el-button size="mini" circle icon="el-icon-search" @click="toggleSearch" />
      </el-tooltip>

      <!-- ② 刷新表格 -->
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <el-button size="mini" circle icon="el-icon-refresh" @click="refresh" />
      </el-tooltip>

      <!-- ③ 显隐列 -->
      <el-tooltip v-if="columns && columns.length" class="item" effect="dark" content="显隐列" placement="top">
        <el-button v-if="showColumnsType === 'transfer'" size="mini" circle icon="el-icon-menu" @click="showColumn" />
        <span v-if="showColumnsType === 'checkbox'" style="padding-left: 12px">
          <el-popover placement="bottom-end" trigger="click" :visible-arrow="false" popper-class="right-toolbar-columns-popover">
            <el-button slot="reference" size="mini" circle icon="el-icon-menu" />
            <div class="right-toolbar-columns-list">
              <label v-for="item in columns" :key="item.key" class="right-toolbar-columns-item">
                <el-checkbox v-model="item.visible" @change="checkboxChange($event, item.label)">
                  {{ item.label }}
                </el-checkbox>
              </label>
            </div>
          </el-popover>
        </span>
      </el-tooltip>
    </el-row>

    <el-dialog :title="title" :visible.sync="open" append-to-body>
      <el-transfer v-model="value" :titles="['显示', '隐藏']" :data="transferData" @change="dataChange" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "RightToolbar",
  props: {
    showSearch: {
      type: Boolean,
      default: true
    },
    columns: {
      type: Array,
      default: () => []
    },
    search: {
      type: Boolean,
      default: true
    },
    showColumnsType: {
      type: String,
      default: "checkbox" // checkbox | transfer
    },
    gutter: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      value: [],
      title: "显示/隐藏",
      open: false
    };
  },
  computed: {
    style() {
      const ret = {};
      if (this.gutter) {
        ret.marginRight = `${this.gutter / 2}px`;
      }
      return ret;
    },
    transferData() {
      return (this.columns || []).map((item, index) => ({
        key: index,
        label: item.label
      }));
    }
  },
  created() {
    if (this.showColumnsType === "transfer" && Array.isArray(this.columns)) {
      this.columns.forEach((item, index) => {
        if (item.visible === false) {
          this.value.push(index);
        }
      });
    }
  },
  methods: {
    toggleSearch() {
      this.$emit("update:showSearch", !this.showSearch);
    },
    refresh() {
      this.$emit("queryTable");
    },
    showColumn() {
      this.open = true;
    },
    dataChange(data) {
      this.columns.forEach((item, index) => {
        item.visible = !data.includes(index);
      });
    },
    checkboxChange(event, label) {
      const target = this.columns.find(item => item.label === label);
      if (target) {
        target.visible = event;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-transfer__button {
  border-radius: 50%;
  display: block;
  margin-left: 0;
}

::v-deep .el-transfer__button:first-child {
  margin-bottom: 10px;
}
</style>

<style lang="scss">
.right-toolbar-columns-popover {
  padding: 6px 0;
  min-width: 160px;
}

.right-toolbar-columns-list {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e5e7eb;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f9fafb;
  }
}

.right-toolbar-columns-item {
  display: block;
  padding: 0 12px;
  line-height: 30px;
  cursor: pointer;

  &:hover {
    background-color: #f5f7fa;
  }
}
</style>
